import type { FC } from 'react';
import type { StyleProp, TextStyle } from 'react-native';
import type { TextProps } from 'react-native-paper';
import { Text } from 'react-native-paper';

import type { AutoLinkPart, LinkType } from '@/shared/components/text/text';

type AutoLinkSegmentProps = {
  part: AutoLinkPart;
  variant?: TextProps<string>['variant'];
  style?: StyleProp<TextStyle>;
  linkStyle?: StyleProp<TextStyle>;
  onPressLink?: (info: { type: LinkType; value: string; href: string }) => void;
};

/**
 * Renders a single segment of text, either as a link or plain text.
 */
export const AutoLinkSegment: FC<AutoLinkSegmentProps> = ({
  part,
  variant,
  style,
  linkStyle,
  onPressLink
}) => {
  if (part.isLink && part.type && part.href && part.value) {
    return (
      <Text
        variant={variant}
        key={part.key}
        style={linkStyle}
        onPress={() =>
          onPressLink?.({
            type: part.type!,
            value: part.value!,
            href: part.href!
          })
        }
        accessibilityRole="link"
      >
        {part.text}
      </Text>
    );
  }

  return (
    <Text variant={variant} style={style} key={part.key}>
      {part.text}
    </Text>
  );
};
